import { setCustomTimeout } from "@client/lib/misc";

export interface AppearOptions {
  onAppear: (element: HTMLElement) => void;
  delay?: string;
}

export default (element: HTMLElement, options: AppearOptions) => {
  const $element = $(element);

  const doAppear = () => {
    options.onAppear(element);
  };

  const appear = () => {
    if (options.delay) {
      setCustomTimeout(doAppear, options.delay);
    } else {
      doAppear();
    }
  };

  $element.appear(appear);
};
